define('core/models/RichMediaViewModel',[
    'backbone',
], function (
    Backbone
) {
    'use strict';

    // This model holds view state for RichMediaView instances
    return Backbone.Model.extend({
        defaults: {
            // If true, media will be displayed inline and load when near viewport.
            // If false, a button will be displayed to load the media.
            // RichMediaView will set based on user preference during initialize.
            deferred: true,

            showButtons: true,

            // Activated tracks if media is displayed
            activated: false,

            // Valid kinds: 'image', 'html', 'webpage'
            kind: 'image',

            // Used to set the height of the placeholder and, in the case of
            // iframe content, the height of the iframe.
            // RichMediaView will calculate an appropriate deferredHeight.
            deferredHeight: 0,

            // Resource-independent provider details that are not contained
            // in the media model. These should be set before the RichMediaView
            // is instantiated.
            providerExpandMessage: '',
            providerCollapseMessage: '',
            providerIcon: 'icon-proceed',

            // Not all RichMedia objects should respect forum/user settings.
            // RichMedia inside Sponsored Comment should not repsect user preferences (because this is an ad)
            respectSettings: true,
        },
    });
});

